<template>
  <n-popover
    v-model:show="isContentShown"
    trigger="click"
    :show-arrow="false"
    :flip="false"
    placement="bottom-start"
    v-bind="$attrs"
    @clickoutside="handleClickOutside"
  >
    <template #trigger>
      <etg-button :class="[{ active: triggerActive }, props.triggerClass]" :type="props.triggerBtnType" :icon="props.triggerIcon">
        {{ props.triggerLabel }}
      </etg-button>
    </template>

    <template #default>
      <div class="filter-popup py-2 bg-white rounded">
        <div class="content relative">
          <slot :visible="isContentShown" :onValidation="handleContentValidation">popup content</slot>
        </div>
        <div v-if="props.isFooterActionsShown" class="actions flex justify-end items-center py-6 px-5 gap-2">
          <etg-button v-if="props.isClearShown" type="tertiary" @click="handleFilterClear">{{ $t('filter.clear') }}</etg-button>
          <etg-button type="primary" :loading="isLoading" :disabled="!isSubmittable" @click="handleSubmit">
            {{ submitLabel }}
          </etg-button>
        </div>
      </div>
    </template>
  </n-popover>
</template>

<script setup lang="ts">
import { NPopover } from 'naive-ui'

import type { EtgButtonProps } from '@/types/component'
import type { IconName } from '@/types/icon'

interface Props {
  triggerLabel?: string
  triggerActive?: boolean
  isClearShown?: boolean
  submitLabel: string
  isLoading?: boolean
  triggerIcon?: IconName
  triggerClass?: string
  triggerBtnType?: EtgButtonProps['type']
  isFooterActionsShown?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  triggerLabel: '',
  triggerActive: false,
  isClearShown: false,
  isLoading: false,
  triggerBtnType: 'secondary',
  isFooterActionsShown: true,
})

const emit = defineEmits<{
  (event: 'clear' | 'submit' | 'close'): void
}>()

const isContentShown = defineModel<boolean>({ default: false })
const isContentValid = ref(true)
const isSubmittable = computed(() => isContentValid.value)

const triggerActive = computed(() => isContentShown.value || props.triggerActive)

const handleFilterClear = () => emit('clear')

const handleSubmit = () => {
  isContentShown.value = false
  emit('submit')
}

const handleClickOutside = () => {
  emit('close')
}

const handleContentValidation = (result: boolean) => {
  isContentValid.value = result
}
</script>
